import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";

import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServicesPage from "@/pages/Services";
import ServiceDetailPage from "@/pages/ServiceDetail";
import ConditionsPage from "@/pages/Conditions";
import ConditionDetailPage from "@/pages/ConditionDetail";
import PreventivePage from "@/pages/Preventive";
import TechnologyPage from "@/pages/Technology";
import { ResourcesIndex, ResourceDetail } from "@/pages/Resources";
import BowelPrepHubPage from "@/pages/BowelPrepHub";
import BowelPrepGuidePage from "@/pages/BowelPrepGuide";
import FaqPage from "@/pages/FAQ";
import { EducationIndex, ArticleDetail } from "@/pages/Education";
import ReferralsPage from "@/pages/Referrals";
import VirtualConsultationsPage from "@/pages/VirtualConsultations";
import NotFoundPage from "@/pages/NotFound";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/services/:slug" element={<ServiceDetailPage />} />
                    <Route path="/conditions" element={<ConditionsPage />} />
                    <Route path="/conditions/:slug" element={<ConditionDetailPage />} />
                    <Route path="/preventive-care" element={<PreventivePage />} />
                    <Route path="/technology" element={<TechnologyPage />} />
                    <Route path="/resources" element={<ResourcesIndex />} />
                    <Route path="/resources/bowel-prep-guide" element={<BowelPrepHubPage />} />
                    <Route path="/resources/bowel-prep-guide/:prepSlug" element={<BowelPrepGuidePage />} />
                    <Route path="/resources/:slug" element={<ResourceDetail />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/education" element={<EducationIndex />} />
                    <Route path="/education/:slug" element={<ArticleDetail />} />
                    <Route path="/referrals" element={<ReferralsPage />} />
                    <Route path="/virtual-consultations" element={<VirtualConsultationsPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
